module.exports = __webpack_public_path__ + "static/media/Daedam9 Translated by J_Lee_77777.9a27647c.md";